import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import ar from "./locales/ar.json";

// ─────────────────────────────────────────────
//  i18n — resource-file localization (resx-style)
//
//  Each language has a JSON resource file under ./locales.
//  Reference a string in a component with:
//      const { t } = useTranslation();
//      t("nav.Dashboard")   // ~ Resources.Nav_Dashboard
//
//  Default language is English; the user's choice is
//  remembered in localStorage under the "appLanguage" key.
// ─────────────────────────────────────────────

export const SUPPORTED_LANGUAGES = ["en", "ar"] as const;
export type AppLanguage = (typeof SUPPORTED_LANGUAGES)[number];

export const RTL_LANGUAGES: AppLanguage[] = ["ar"];

export const isRtl = (lng: string): boolean =>
  RTL_LANGUAGES.includes(lng as AppLanguage);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      ar: { translation: ar },
    },
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGUAGES as unknown as string[],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      // Prefer an explicit saved choice; otherwise fall back to English.
      order: ["localStorage"],
      lookupLocalStorage: "appLanguage",
      caches: ["localStorage"],
    },
  });

export default i18n;
